export const CalendarTickSVG = ({ className }: { className?: string }) => {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 17 17"
        >
            <path
                d="M12.9 9.1L8 14c-.1.1-.1.1-.2.1s-.2 0-.2-.1l-2.7-2.7c-.1-.1-.1-.1-.1-.2s0-.2.1-.2l.4-.4c.1-.1.1-.1.2-.1s.2 0 .2.1l2.1 2.1L12 8.3c.1-.1.1-.1.2-.1s.2 0 .2.1l.4.4c.1.1.1.1.1.2v.2zM1.7 15.8h13.4V6.1H1.7v9.7zM5.4 4.3V1.5c0-.1 0-.2-.1-.2s-.2-.1-.2-.1h-.7c-.1 0-.2 0-.2.1s-.1.1-.1.2v2.7c0 .1 0 .2.1.2.1.1.1.1.2.1H5c.1 0 .2 0 .2-.1.1 0 .2-.1.2-.1zm7.2 0V1.5c0-.1 0-.2-.1-.2s-.1-.1-.2-.1h-.6c-.1 0-.2 0-.2.1-.1.1-.1.1-.1.2v2.7c0 .1 0 .2.1.2.1.1.1.1.2.1h.6c.1 0 .2 0 .2-.1.1 0 .1-.1.1-.1zm3.7-.7v12.1c0 .3-.1.6-.4.9-.2.2-.5.4-.9.4H1.7c-.3 0-.6-.1-.9-.4-.2-.2-.4-.5-.4-.9V3.6c0-.3.1-.6.4-.9s.5-.4.9-.4h1.2v-.8c0-.4.1-.8.4-1.1S4 0 4.4 0H5c.4 0 .8.1 1.1.4.3.3.4.7.4 1.1v.9h3.6v-.9c0-.4.1-.8.4-1.1s.8-.4 1.2-.4h.6c.4 0 .8.1 1.1.4.3.3.4.7.4 1.1v.9H15c.3 0 .6.1.9.4s.4.5.4.8z"
                fill="#565656"
            />
        </svg>
    );
};
